import { render, staticRenderFns } from "./LegalCompliance.vue?vue&type=template&id=8b95e65c"
import script from "./LegalCompliance.vue?vue&type=script&lang=js"
export * from "./LegalCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports